import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slice/authSlice';
import bookingReducer from './slice/bookingSlice';
import categoryReducer from './slice/categorySlice';
import packageReducer from './slice/packageSlice';
import salonReducer from './slice/salonSlice';
import serviceReducer from './slice/serviceSlice';
import transactionReducer from './slice/transactionSlice';
import userReducer from './slice/userSlice';
import vendorReducer from './slice/vendorSlice';
import withdrawRequestReducer from './slice/withdrawRequestSlice';
import vendorBankAccountReducer from './slice/vendorBankAccountSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    booking: bookingReducer,
    category: categoryReducer,
    package: packageReducer,
    salon: salonReducer,
    service: serviceReducer,
    transaction: transactionReducer,
    user: userReducer,
    vendor: vendorReducer,
    withdrawRequest: withdrawRequestReducer,
    vendorBankAccount: vendorBankAccountReducer,
  },
});

export default store;
